<template >
  <v-footer
    height="auto"
    style="background: #242c42"
    class="print-hide px-0"
  >
    <FooterContent></FooterContent>
  </v-footer>
</template>

<script>
import FooterContent from '../footercontent/FooterContent'

export default {
  name: 'FooterLayout',
  components: {
    FooterContent
  },
  data: () => ({
  })
}
</script>
